var React = require('react');
var createReactClass = require('create-react-class');
var _ = require('lodash');
var PracticeHeader = require('./practiceHeader');
var PartialRegisterBox = require('../../components/partialRegisterBox');
var PracticeFooter = require('./practiceFooter');
var { getSubdomain } = require('../../../modules/practice/practiceUtils');

var PracticeLandingPage = createReactClass({
  componentDidMount: function () {
    if (_.isEmpty(this.props.practice.data)) {
      // get practice on refresh or if needed
      const subdomain = getSubdomain();
      if (subdomain) {
        this.props.setPracticeFromSubdomain(subdomain);
      }
    }
  },

  render: function () {
    return (
      <div className="outer-wrapper">
        <div className="wrapper">
          <PracticeHeader practice={this.props.practice.data} />
          <section className="page">
            <PartialRegisterBox
              auth={this.props.auth}
              partialSignUp={this.props.partialSignUp}
              clearRegError={this.props.clearRegError}
              loginRedirectUrl="/dashboard/surveys/gihistory"
              recordRegisterClick={this.props.recordRegisterClick}
            />
          </section>
          <div className="dummy-footer"></div>
        </div>
        <PracticeFooter practice={this.props.practice.data} />
      </div>
    );
  },
});

module.exports = PracticeLandingPage;



// WEBPACK FOOTER //
// ./src/common/routes/practice/components/practiceLandingPage.jsx